import React, { Component } from "react";
import { Grid } from "react-bootstrap";

import { WidgetChatbot } from "../Chat/Widget.jsx";


class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <Grid fluid>
          <nav className="pull-left">
            
          </nav>
          <p className="copyright pull-right">
            &copy; {new Date().getFullYear()}{" "}
            Movti
          </p>
        </Grid>
      </footer>
    );
  }
}

export default Footer;
